export const leadKeys = {
  all: ["autoleads", "lead"] as const,
  list: (params?: { campaign?: number; supervisor?: boolean }) =>
    [
      ...leadKeys.all,
      "list",
      params?.campaign ?? null,
      params?.supervisor ?? false,
    ] as const,
  detail: (leadId: number) => [...leadKeys.all, "detail", leadId] as const,
}
